export const animateToTop = () => {
  const scrollToTop = window.setInterval(function () {
    const pos = window.pageYOffset
    if (pos > 0) {
      window.scrollTo(0, pos - 20)
    } else {
      window.clearInterval(scrollToTop)
    }
  }, 16)
}

export const scrollToXY = (x, y) => {
  window.scrollTo(x, y)
}

export const animateToPosition = (y) => {
  if (window.pageYOffset > y) {
    const scrollToPosition = window.setInterval(() => {
      const pos = window.pageYOffset
      if (pos > y) {
        scrollToXY(0, pos - 20)
      } else {
        window.clearInterval(scrollToPosition)
      }
    }, 16)
  } else if (window.pageYOffset < y) {
    const scrollToPosition = window.setInterval(() => {
      const pos = window.pageYOffset
      if (pos < y) {
        scrollToXY(0, pos + 20)
      } else {
        window.clearInterval(scrollToPosition)
      }
    }, 16)
  }
}

export const stopWindowScroll = (e, id) => {
  const ele = document.getElementById(id).getElementsByTagName("div")[0]

  if (e.nativeEvent.deltaY <= 0) {
    // scrolling up
    if (ele.scrollTop <= 0) {
      e.preventDefault()
    }
  } else {
    // scrolling down
    if (ele.scrollTop + ele.clientHeight >= ele.scrollHeight) {
      e.preventDefault()
    }
  }
}
